import { useSharedValue } from 'react-native-reanimated';

export function useAnimatedKeyboard() {
  const sharedValue = useSharedValue(0);

  return {
    height: sharedValue
  };
}
